export default function humanDate(timestamp, yearDigits = '2-digit') {
	return new Date(timestamp).toLocaleDateString('en-GB', {
		day: 'numeric',
		month: 'short',
		year: `${yearDigits}`,
	})
}
